import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPageMeta, metaForPath } from '@/lib/pageMeta';

/**
 * Applies each route's <head> metadata on navigation. Mounted inside the
 * Router, above the routes, so it runs before any page's own usePageMeta call
 * and a page override always wins. Renders nothing.
 *
 * Only the pathname is a dependency: query strings (/search?q=...) are facets
 * of one page, and giving each of them a canonical of its own would recreate
 * the duplicate-URL problem this exists to fix.
 */
export default function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMeta(metaForPath(pathname));
  }, [pathname]);

  return null;
}
